import { RoutePathMatch } from '../enum/route-path-match.enum';

export const RouterMap = (navigate: RoutePathMatch) => {
  switch (navigate) {
    default:
      return [...navigate.split('/')];
  }
};
